export default __webpack_public_path__ + "static/media/naidi-2-5.e1c42803.svg";